// extracted by mini-css-extract-plugin
export default {"button":"v3bgKDeGwbph4VqSUVyC","placeHolderShimmer":"QdfY3Hwg6L128tDdsn5J"};